<template>
  <component :is="activeSessionType" />
</template>

<script>
import { useActiveUserStore } from '@/stores/user';
import { defineAsyncComponent } from 'vue';

const Customer = defineAsyncComponent(() => import('./Customer/index.vue'));
const Maker = defineAsyncComponent(() => import('./Maker/index.vue'));
const Admin = defineAsyncComponent(() => import('./Admin/index.vue'));

export default {
  components: {
    Customer,
    Maker,
    Admin,
  },

  setup() {
    const store = useActiveUserStore();
    return {
      activeSessionType: store.activeSessionType,
    };
  },
};
</script>
